import React, { Component } from "react";
import PropTypes from "prop-types";
import CoreCard from "./CoreCard";
import { withStyles } from "@material-ui/core/styles";
import { withTheme } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import { Trans, withTranslation } from "react-i18next";
import InsertChartIcon from "@material-ui/icons/InsertChart";
import PieChartIcon from "@material-ui/icons/PieChart";
import TimelineIcon from "@material-ui/icons/Timeline";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { AutoSizer } from "react-virtualized";
import Media from "react-media";
import axios, { reportClient } from "../AxiosClient";
import { HorizontalBar, Bar, Line, Pie } from "react-chartjs-2";
import { getColours } from "../components/editor/util/ChartUtils";

const styles = (theme) => ({
  statsContainer: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  table: {
    overflow: "auto",
  },
  header: {
    position: "sticky",
    top: 0,
    backgroundColor: theme.palette.common.white,
  },
  graphToolbar: {
    width: "100%",
    height: 40,
    backgroundColor: theme.palette.common.white,
  },
  tabContainer: {
    flexWrap: "wrap",
  },
  tabs: {
    marginBottom: 10,
    // marginTop: -25,
  },
});
let Chart;
export class CardStats extends Component {
  static propTypes = {
    portlet: PropTypes.object.isRequired,
    expanded: PropTypes.bool,
    fullscreen: PropTypes.bool,
  };

  state = {
    data: [],
    instance: Date.now().toString(),
    selectedTab: 0,
    chartType: "bar",
  };
  componentDidMount() {
    if (this.props.expanded) {
      this.getData();
    }
    if (window.localStorage.getItem("selectedTime")) {
      this.setState({
        selectedTab: parseInt(window.localStorage.getItem("selectedTime")),
      });
    }
    if (window.localStorage.getItem("selectedChart")) {
      this.setState({
        chartType: window.localStorage.getItem("selectedChart"),
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.message !== this.props.message) {
      let message = this.props.message;
      if (message.instance === this.props.portlet.instance) {
        if (message.type === "com.kpsol.api.apicommon.stats.MyStatsInterface") {
          if (message.method === "getAll") {
            this.setState({ data: message.messageArray });
          }
        }
      }
    }
  }
  renderChart = (type, height, width, ele, header, conducted) => {
    let { classes, t } = this.props;
    let data = {
      labels: [],
      datasets: [],
    };
    if (type === "pie") {
      Chart = Pie;
      data.labels = ele.dataObject.pie.map((e) => t(e.id));
      data.datasets = [
        {
          label: "",
          data: ele.dataObject.pie.map((e) => e.value),
          backgroundColor: getColours(ele.dataObject.pie.length, false, 0.6),
          borderColor: getColours(ele.dataObject.pie.length, false, 1),
          borderWidth: 1,
          hoverOffset: 25,
        },
      ];
    } else if (type === "line") {
      Chart = Line;
      data.labels = ele.dataObject.bar.map((e) => t(e.activity));
      data.datasets = [
        {
          label: "",
          data: ele.dataObject.bar.map((e) => e.times),
          backgroundColor: "rgba(54, 162, 235, 0.3)",
          borderColor: "rgb(54, 162, 235)",
          borderWidth: 1,
        },
      ];
    } else if (type === "bar") {
      data.labels = ele.dataObject.bar.map((e) => t(e.activity));
      Chart =
        this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.stats.TopicStatsInterface" ||
        this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.stats.TopicDocumentStatsInterface"
          ? HorizontalBar
          : Bar;
      data.datasets = [
        {
          label: "",
          data: ele.dataObject.bar.map((e) => e.times),
          backgroundColor: getColours(ele.dataObject.bar.length, false, 0.3),
          borderColor: getColours(ele.dataObject.bar.length, false, 1),
          borderWidth: 1,
        },
      ];
    }
    return (
      <div
        style={{
          position: "relative",
          width,
          height,
        }}
      >
        <Chart
          data={data}
          options={{
            responsive: true,
            legend: { 
              display: false,
            },
            padding: {
              bottom: 18,
            },
            maintainAspectRatio: false,
            scales:
              type === "pie"
                ? {}
                : {
                    xAxes: [{ ticks: { min: 0 } }],
                    yAxes: [{ ticks: { min: 0 } }],
                  },
          }}
        />
      </div>
    );
  };

  render() {
    let { classes, t } = this.props;
    return (
      <div style={{ height: "100%" }}>
        <Tabs
          value={this.state.selectedTab}
          onChange={this.handleTabChange}
          indicatorColor="primary"
          classes={{ flexContainer: classes.tabContainer }}
          className={classes.tabs}
          textColor="primary"
        >
          {this.state.data.map((ele) => {
            return <Tab key={ele.title} label={t("global_" + ele.title)} />;
          })}
        </Tabs>
        <div style={{ height: "100%" }}>
          <AutoSizer>
            {({ height, width }) => (
              <>
                {this.generateChartDisplay(height, width)}
              </>
            )}
          </AutoSizer>
        </div>
      </div>
    );
  }

  generateChartDisplay = (height,width) => {
    let { classes, t, theme } = this.props;
    const chartHeight = height - theme.spacing(20)
    const chartWidth = width * 0.6
    const header =
    this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.stats.TopicStatsInterface" ||
    this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.stats.TopicDocumentStatsInterface"
      ? t("report_column_topicName")
      : t("stats_activity_header");
    const conducted =
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.stats.TopicStatsInterface"
        ? t("report_column_numViews")
        : this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.stats.TopicDocumentStatsInterface"
          ? t("report_column_numDocuments")
          : t("stats_times_conducted_header");
    return (
      <>

        {this.state.data.map((ele, idx) => {
          const pieColours = getColours(ele.dataObject.bar.length, false, 0.6)
          let legendData = 
            this.state.chartType === "pie" ? 
              ele.dataObject.pie.sort((a, b) => {
                return a.value > b.value
                  ? -1
                  : a.value < b.value
                    ? 1
                    : 0;
              })
            : ele.dataObject.bar.sort((a, b) => {
              return a.times > b.times
                ? -1
                : a.times < b.times
                  ? 1
                  : 0;
            })

          return (
            <>
              {this.state.selectedTab === idx && (
                <div
                  className={classes.statsContainer}
                  style={{ display: this.props.width < 3 ? "block" : null }}
                >
                  <div
                    // className={classes.table}
                    // style={{
                    //   // height: this.props.height * 0.5,
                    //   // height: height
                    //   // flex: 0.3,
                    //   // flexShrink: 0,
                    // }}
                  >
                    <TableContainer
                      style={{
                        // width: width - theme.spacing(2),
                        maxHeight: height - theme.spacing(10),
                        maxWidth: width * 0.4
                      }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            {this.state.chartType !== "line" &&
                              <TableCell size="small" className={classes.header}>
                              </TableCell>
                            }
                            <TableCell size="small" className={classes.header}>
                              <Trans i18nKey={header} />
                            </TableCell>
                            <TableCell size="small" className={classes.header} align="right">
                              <Trans i18nKey={conducted} />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {legendData.map((ele,idx) => {
                              return (
                                <TableRow>
                                  {this.state.chartType !== "line" &&
                                    <TableCell size="small" component="th" scope="row">
                                      <div style={{backgroundColor: pieColours[idx], width: theme.spacing(2), height: theme.spacing(2)}}>
                                      </div>
                                    </TableCell>
                                  }
                                  <TableCell size="small" component="th" scope="row">
                                    <Trans i18nKey={ele.hasOwnProperty("activity") ? ele.activity : ele.id} />
                                  </TableCell>
                                  <TableCell size="small" align="center">
                                    {ele.hasOwnProperty("times") ? ele.times : ele.value}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                  <div
                    // style={{
                    //   height: this.props.height * 0.5,
                    //   flex: 0.7,
                    //   flexShrink: 1,
                    // }}
                    style={{width: width * 0.6, minWidth: theme.spacing(30)}}
                  >
                    <div className={classes.graphToolbar}>
                      <Tooltip title={t("stats_view_bar_chart")}>
                        <span>
                          <IconButton
                            disabled={this.state.chartType === "bar"}
                            onClick={this.renderBarChart}
                            style={{ marginLeft: 30 }}
                          >
                            <InsertChartIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title={t("stats_view_line_chart")}>
                        <span>
                          <IconButton
                            disabled={this.state.chartType === "line"}
                            onClick={this.renderLineChart}
                          >
                            <TimelineIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title={t("stats_view_pie_chart")}>
                        <span>
                          <IconButton
                            disabled={this.state.chartType === "pie"}
                            onClick={this.renderPieChart}
                          >
                            <PieChartIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </div>
                    {this.state.chartType === "bar" && (
                      <>
                        {this.isChartEmpty(ele.dataObject.bar, "times") ? (
                          <Typography style={{ padding: 20 }}>
                            <Trans i18nKey="activity_no_data_to_display" />
                          </Typography>
                        ) : (
                          <>
                            {this.renderChart(
                              "bar",
                              chartHeight,
                              chartWidth,
                              ele,
                              header,
                              conducted
                            )}
                          </>
                        )}
                      </>
                    )}

                    {this.state.chartType === "line" && (
                      <>
                        {this.isLineChartEmpty(ele.dataObject.line) ? (
                          <Typography style={{ padding: 20 }}>
                            <Trans i18nKey="activity_no_data_to_display" />
                          </Typography>
                        ) : (
                          <>
                            <Media query="(max-width: 1500px)">
                              {(matches) =>
                                matches ? (
                                  <Typography style={{ padding: 20 }}>
                                    <Trans i18nKey="activity_screen_too_small" />
                                  </Typography>
                                ) : (
                                  // <AutoSizer>
                                  //   {({ height, width }) =>
                                    <>
                                      {this.renderChart(
                                        "line",
                                        chartHeight,
                                        chartWidth,
                                        ele,
                                        header,
                                        conducted
                                      )}
                                    </>

                                )
                              }
                            </Media>
                          </>
                        )}
                      </>
                    )}

                    {this.state.chartType === "pie" && (
                      <>
                        {this.isChartEmpty(ele.dataObject.pie, "value") ? (
                          <Typography style={{ padding: 20 }}>
                            <Trans i18nKey="activity_no_data_to_display" />
                          </Typography>
                        ) : (
                            <>
                              {this.renderChart(
                                "pie",
                                chartHeight,
                                chartWidth,
                                ele,
                                header,
                                conducted
                              )}
                            </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </>
          );
        })}
      </>
    )
  }
  isLineChartEmpty = (data) => {
    for (let ele of data) {
      for (let timeEntry of ele.data) {
        if (timeEntry.y > 0) {
          return false;
        }
      }
    }
    return true;
  };

  isChartEmpty = (data, key) => {
    for (let ele of data) {
      if (ele[key] !== 0) {
        return false;
      }
    }
    return true;
  };

  renderBarChart = () => {
    this.setState({ chartType: "bar" });
    window.localStorage.setItem("selectedChart", "bar");
  };

  renderLineChart = () => {
    this.setState({ chartType: "line" });
    window.localStorage.setItem("selectedChart", "line");
  };

  renderPieChart = () => {
    this.setState({ chartType: "pie" });
    window.localStorage.setItem("selectedChart", "pie");
  };

  handleTabChange = (_e, value) => {
    this.setState({ selectedTab: value });
    window.localStorage.setItem("selectedTime", value);
  };

  getData = () => {
    if (this.props.expanded) {
      let url =
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.stats.ActivityStatsInterface"
          ? "/activitystats/"
          : this.props.portlet.objectClass ===
            "com.kpsol.api.apicommon.stats.TopicStatsInterface"
            ? "/topicstats/views"
            : this.props.portlet.objectClass ===
              "com.kpsol.api.apicommon.stats.TopicDocumentStatsInterface"
              ? "/topicstats/documents"
              : "/mystats/";

      reportClient.get(url).then((res) => {
        this.setState({ data: res.data });
      });
    }
  };
}
export default withTranslation()(
  withTheme(CoreCard(withStyles(styles)(CardStats)))
);
